module.exports = __webpack_public_path__ + "img/logo.c8959e19.png";